import React, { useEffect, useState } from 'react';
import { Typography, Paper } from '@mui/material';
import { styled } from '@mui/system';
import axios from 'axios';

const InfoBox = styled(Paper)({
    backgroundColor: '#202020',
    padding: '1.5rem',
    borderRadius: '8px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
    textAlign: 'left',
    color: '#fff',
    marginBottom: '1rem',
    width: '100%',
});

// 🏷️ Map your Stripe Product IDs to Plan Labels
const planNameMap = {
    'prod_SNxHuh6Ha0WYk3': 'Gold Plan',
    'prod_SNxHHgzEh1Dol7': 'Platinum Plan',
};

const NextBillingDate = ({ user }) => {
    const [nextBillingText, setNextBillingText] = useState('Your default plan is pay as you go until you start your subscription');

    useEffect(() => {
        const fetchUserBillingDetails = async () => {
            if (user && user.stripeCustomerId) {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/stripe/subscription-status`, {
                        params: { customerId: user.stripeCustomerId },
                    });

                    const { isActive, isPaused, nextBillingDate } = response.data;

                    const currentPlan = user?.planDetails?.find(plan => plan.isRecurring && !plan.isPaused);
                    const planLabel = planNameMap[currentPlan?.type] || 'Unknown Plan';

                    if (isActive) {
                        if (isPaused) {
                            setNextBillingText(`Your ${planLabel} is currently paused. You are now on pay-as-you-go.`);
                        } else if (nextBillingDate) {
                            setNextBillingText(`You're on the ${planLabel}. Your next billing date is ${new Date(nextBillingDate).toLocaleDateString()}.`);
                        } else {
                            setNextBillingText(`You're on the ${planLabel}, but the next billing date is unavailable.`);
                        }
                    } else {
                        setNextBillingText('Your default plan is pay as you go until you start your subscription.');
                    }
                } catch (error) {
                    console.error('Failed to fetch billing details:', error);
                    setNextBillingText('Your default plan is pay as you go until you start your subscription.');
                }
            }
        };

        fetchUserBillingDetails();
    }, [user]);

    return (
        <InfoBox>
            <Typography variant="h6">Next Billing Date</Typography>
            <Typography variant="body2" style={{ marginTop: '0.5rem' }}>
                {nextBillingText}
            </Typography>
        </InfoBox>
    );
};

export default NextBillingDate;
